import React from 'react';
import { Select, Box, Text } from '@chakra-ui/react';

interface TimeRangeSelectorProps {
  value: string;
  onChange: (timeRange: string) => void;
}

const TimeRangeSelector: React.FC<TimeRangeSelectorProps> = ({ value, onChange }) => {
  const timeRangeOptions = [
    { value: '7d', label: 'Last 7 days' },
    { value: '30d', label: 'Last 30 days' },
    { value: '90d', label: 'Last 90 days' }
  ];

  return (
    <Box display="flex" alignItems="center" gap={2}>
      <Text fontSize="sm" color="gray.600" fontWeight="medium">
        Time Range:
      </Text>
      <Select
        size="sm"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        bg="white"
        borderColor="gray.300"
        borderRadius="md"
        fontSize="sm"
        width="140px"
        _hover={{ borderColor: "gray.400" }}
        _focus={{ borderColor: "blue.500", boxShadow: "0 0 0 1px #3182ce" }}
      >
        {timeRangeOptions.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </Select>
    </Box>
  );
};

export default TimeRangeSelector; 